import Util from './Util';
import compareAppVersion from "../../util/compareAppVersion";
var sendRequest = null;
// (async() => {
//     if(window.PPDWebUI) {
        let module = require('../../ppdNetwork/index');
        window.PPDWebUI && (sendRequest = module.default);
//     }
// })();

/*
** script 的 data-params 类似于：
** appId=10003001&bizId=10008&url=/api/webuimonitor/monitorWebUiService/h5DataReprot
** method也是可配
*/
export default class Report {
    constructor(option) {
        this.paramsObj = Util.getParamsFormScript('monitorJs', 'data-params');
        this.buildType = this.paramsObj.buildType || Util.getUseragentKey().buildType;
        this.h5_REPORT_URL = this.paramsObj.url || '/webuimonitor/monitorWebUiService/h5DataReprot';
        this.inApp = window.PPDWebUI && window.PPDWebUI.os && window.PPDWebUI.os.inApp || false;
        this.baseConfig = {
            method: this.paramsObj.method || 'post',
            url: this.h5_REPORT_URL,
            ledsdk: this.paramsObj.ledsdk || '',
            data: option,
            callback: ''
        };
    }
    sendRequest () {
        let obj = this.baseConfig;
        if (this.inApp) {
            this.sendByNative(obj);
        }else {
            this.sendByH5(obj);
        }
    }

    sendByNative(obj) {
        let data = obj.data;
        window.PPDWebUI.MonitorService && window.PPDWebUI.MonitorService.monitor(data, function () {
            console.log('上报成功');
        }, function () {
            console.log('上报失败');
        });
    }

    sendReport(params) {
        return {
            method: this.paramsObj.method || 'post',
            url: this.h5_REPORT_URL,
            params,
            showNetToast: false,
            showBusinessToast: false,
            showLoading: false
        };
    }

    sendByH5(obj) {
        obj = this.baseConfig;
        let plusData = {
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: Util.setTimestamp(new Date()),
            platform: Util.getUseragentKey().platform,
            duid: Util.getUseragentKey().duid,
            pid: Util.getUseragentKey().pid,
            appId: Util.getUseragentKey().appId || this.paramsObj.appId||Util.getMiappUseragentKey().appId,
            version: Util.getUseragentKey().version,
            openid: Util.getUseragentKey().openid || '',
            bizId: this.paramsObj.bizId || '',
            buildType: String(this.buildType)
        };
        // let cp = Util.getUseragentKey().cp;
        // let _data = Object.assign({}, obj.data, plusData);
        let _data = Object.assign({}, plusData, this.extendParams, obj.data);
        let params = {
            jsonBody: _data
        };


        if (this.inApp && compareAppVersion(PPDWebUI.appInfos.version, '9.8.0', '>', true)) {
            this.sendByNative({
                data: {
                    ...obj.data,
                    ...plusData
                }
            });
        } else {
            let xhr = new XMLHttpRequest();
            let url = window.location.origin + obj.url;
            if (obj.method === 'get') {
                xhr.open('GET', this.h5_REPORT_URL + '?jsonBody=' + encodeURIComponent(JSON.stringify(_data), true));
                // 如果是多租户网关，需要设置一堆header
                if(obj.ledsdk === 'true' || url.includes('ledsdk.com')) {
                    xhr.setRequestHeader('X-GW-TIMESTAMP', parseInt(new Date().getTime() / 1000));
                    xhr.setRequestHeader('X-GW-DEVICEID', 'h5')
                    xhr.setRequestHeader('X-GW-PLATFORM', 'h5');
                    xhr.setRequestHeader('X-GW-APPID', obj.appId || '1000003198');
                    xhr.setRequestHeader('X-GW-TENANTID', '5cf1baf1');
                    xhr.setRequestHeader('X-GW-CHANNELAPP', 'other');
                    xhr.setRequestHeader('X-GW-CHANNELNAME', 'h5');
                }
                xhr.send(null);
            } else if (obj.method === 'post') {
                if(sendRequest) {
                    sendRequest(this.sendReport(params));
                    return;
                }
                xhr.open('POST', url, true);
                xhr.setRequestHeader('Content-type', 'application/json;charset=UTF-8')
                xhr.setRequestHeader('X-PPD-APPOS', Util.getUseragentKey().appos);
                xhr.setRequestHeader('X-PPD-APPID', Util.getUseragentKey().appId);
                xhr.setRequestHeader('X-PPD-APPVERSION', Util.getUseragentKey().version);
                xhr.setRequestHeader('X-PPD-TIMESTAMP', parseInt(new Date().getTime() / 1000));

                xhr.send(JSON.stringify(params))
            }
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4 && xhr.status == 200) {
                    obj.callback && obj.callback(xhr.responseText)
                }
            }
        }
    }
}
